import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionDirective } from './permission.directive';

@NgModule({
  imports: [TranslateModule.forChild({})],
  declarations: [PermissionDirective],
  exports: [PermissionDirective],
})
export class PermissionModule {}
